import React, { useState ,useEffect} from 'react';
import { Box } from '@mui/material';
import NotificationBox from './NotificationBox'; // Adjust the import path as needed

const NotificationContainer = ({notification}) => {

  const [notifications, setNotifications] = useState([]);

  const handleClose = (id) => {
    setNotifications(notifications.filter(notification => notification.id !== id));
  };

useEffect(()=>{
    const type = notification?.type;
    const title = notification?.message?.title?.split('_')?.join('_\u200B');
    const description = notification?.message?.description?.split('_')?.join('_\u200B');

    if (type) {
      setNotifications(prev => ([...prev,
        {id:(prev.length > 0 ? prev[prev.length - 1].id : 0) + 1, 
            type : type,
            title : title,
            description : description
        }
        ]))
    }
},[notification]);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        width: '20%',
        zIndex: 9999,
        maxHeight: '100vh', overflow: 'auto'
      }}
    >
      {notifications?.slice()?.reverse()?.map(notification => (
        <NotificationBox
          key={notification?.id}
          type={notification?.type}
          title={notification?.title}
          description={notification?.description || ""}
          onClose={() => handleClose(notification?.id)}
        />
      ))}
    </Box>
  );
};

export default NotificationContainer;
